/* tslint:disable */
/* eslint-disable */
/* @relayHash 68ccfacb3bfa476eb170a93a343e3797 */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationPdpSourcingModalConfigQueryVariables = {
    itemIds: Array<string | null>;
    userId?: string | null;
};
export type pdpSharedNotificationPdpSourcingModalConfigQueryResponse = {
    readonly viewer: {
        readonly itemRead: ReadonlyArray<{
            readonly displayInfo?: {
                readonly ctas: {
                    readonly showRequestSourcing: boolean | null;
                } | null;
            } | null;
        } | null> | null;
    };
};
export type pdpSharedNotificationPdpSourcingModalConfigQuery = {
    readonly response: pdpSharedNotificationPdpSourcingModalConfigQueryResponse;
    readonly variables: pdpSharedNotificationPdpSourcingModalConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v2 = {
  "kind": "InlineFragment",
  "type": "Item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "displayInfo",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ctas",
          "storageKey": null,
          "args": null,
          "concreteType": "CTADisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showRequestSourcing",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemRead",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "id": "app-buyer-finding/255.0.0-2020-03-12T11:29:58.203Z/pdpSharedNotificationPdpSourcingModalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '27f07ee2b2a46b99d7ea94efab16380f';
export default node;
